import { readCart, cleanBundleCart } from './noraviro-bundle-cart-v2.js';
import { CartItemsComponent } from './component-cart-items.js';
(() => {
  let busy = false;
  async function checkout(button) {
    if (busy) return;
    busy = true;
    button.disabled = true;
    const root = window.Shopify?.routes?.root || '/';
    try {
      while (CartItemsComponent.pendingQuantityUpdates.length) {
        await Promise.all(CartItemsComponent.pendingQuantityUpdates);
      }
      const cart = await cleanBundleCart(await readCart());
      if (!cart.items.length) { window.location.assign(root + 'cart'); return; }
      const bottles = cart.items.filter(item => String(item.variant_id) === '61727939985548');
      if (bottles.length) {
        const quantity = bottles.reduce((sum, item) => sum + item.quantity, 0);
        const total = bottles.reduce((sum, item) => sum + item.final_line_price, 0);
        if (![1,2,3].includes(quantity) || bottles.some(item => !item.selling_plan_allocation) || total !== quantity * 4995) {
          throw new Error('Please return to the product page and choose Buy 1, Buy 2 or Buy 3.');
        }
      }
      window.location.assign(root + 'checkout');
    } catch (error) {
      window.alert(error.message || 'Unable to open checkout. Please try again.');
      button.disabled = false;
      busy = false;
    }
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('button[name="checkout"]');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkout(button);
  }, true);
  document.addEventListener('submit', event => {
    const button = event.submitter;
    if (!button?.matches('[name="checkout"]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkout(button);
  }, true);
  async function cleanOnArrival() {
    try {
      if (!document.querySelector('cart-items-component')) return;
      const cart = await readCart();
      const cleaned = await cleanBundleCart(cart);
      if (cleaned !== cart) window.location.reload();
    } catch (error) { console.warn(error.message); }
  }
  cleanOnArrival();
})();
